/* Scripts para Ocultar Productos */

if (window.location.href.indexOf("gift-wrapping") > -1){
    window.location.replace("https://www.ilargentousa.com/");
};

if (window.location.href.indexOf("printed-travel-tin-set-of-2") > -1){
    window.location.replace("https://www.ilargento.com/products/printed-travel-tin-aloha-orchid");
};

if (window.location.href.indexOf("gift-honey-sticks") > -1){
    window.location.replace("https://www.ilargentousa.com/");
};

if (window.location.href.indexOf("gift-match-box") > -1){
    window.location.replace("https://www.ilargentousa.com/");
};


var urlsSetGoldenHandles = [
  "golden-handles-white-and-gold-3-part-server-hidden",
  "golden-handles-white-and-gold-deep-long-server-hidden",
  "golden-handles-white-and-gold-large-round-bowl-hidden",
  "golden-handles-white-and-gold-mini-rectangular-bowl-set-of-4-hidden",
  "golden-handles-white-and-gold-oval-baking-dish-hidden",
  "golden-handles-white-and-gold-rectangular-baking-dish-hidden",
  "golden-handles-white-and-gold-small-platter-hidden",
  "golden-handles-white-and-gold-square-baking-dish-hidden"
];
for (var i = 0; i < urlsSetGoldenHandles.length; i++) {
    if (window.location.href.indexOf(urlsSetGoldenHandles[i]) > -1) {
        window.location.replace("https://www.ilargento.com/products/golden-handles-sets");
        break;
    }
}



/* Estilos Cart  Custom*/

function $reindexacionRebuy(){
  $('#rebuy-cart .rebuy-cart__flyout').prepend('<div class="rebuy-new-cart"><div class="container-rebuy-cart-new"></div></div>');
  $( "#rebuy-cart .rebuy-new-cart .container-rebuy-cart-new" ).append($( ".rebuy-cart__flyout-header, .rebuy-cart__flyout-body, .rebuy-cart__flyout-footer" ));
  $('#rebuy-cart .rebuy-new-cart').append('<div data-rebuy-id="157728"></div>');
  $('#rebuy-cart .rebuy-cart__flyout-content').prepend('<div class="container-progress-bar-move"></div>');
  $( "#rebuy-cart .rebuy-cart__flyout-content .container-progress-bar-move" ).prepend($( "#rebuy-cart .rebuy-cart__flyout-body .rebuy-cart__progress-bar-container" ));

  $('.rebuy-cart__flyout-content .rebuy-cart__flyout-recommendations').before(
    '<div id="stars-rebuy-show">' + 
      '<div class="stars">' + 
        '<svg version="1.1" id="stars-reviews-rebuy-cart" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 67 11.2" style="enable-background:new 0 0 67 11.2;" xml:space="preserve">' +
          '<g>' +
            '<polygon points="7.4,4.1 5.9,0 4.4,4.1 0,4.3 3.4,7 2.2,11.2 5.9,8.8 9.5,11.2 8.3,7 11.8,4.3"/>' +
          	'<polygon points="21.2,4.1 19.7,0 18.2,4.1 13.8,4.3 17.2,7 16,11.2 19.7,8.8 23.3,11.2 22.2,7 25.6,4.3"/>' +
          	'<polygon points="29.8,11.2 33.5,8.8 37.2,11.2 36,7 39.4,4.3 35,4.1 33.5,0 32,4.1 27.6,4.3 31,7"/>' +
          	'<polygon points="48.8,4.1 47.3,0 45.8,4.1 41.4,4.3 44.8,7 43.7,11.2 47.3,8.8 51,11.2 49.8,7 53.2,4.3"/>' +
          	'<polygon points="67,4.3 62.6,4.1 61.1,0 59.6,4.1 55.2,4.3 58.7,7 57.5,11.2 61.1,8.8 64.8,11.2 63.6,7"/>' +
          '</g>' +
        '</svg>' +
      '</div>' + 
      '<div class="message">' + 
        '<p><em>Thousands of Satisfied Customers</em></p>' + 
      '</div>' + 
    '</div>'
  );
  
};

function ajustarAltura() {
  var alturaVisible = window.innerHeight + "px";
  document.querySelector('.container-rebuy-cart-new').style.height = alturaVisible;
  console.log(alturaVisible);
};

window.addEventListener("resize", ajustarAltura);




/* Script Gift Wrapping */

function giftWrapping(){
  $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content #stars-rebuy-show').before(
    '<div class="rebuy-cart__flyout-gift" style="display:none;">' +
      '<div class="message-success-gift">' +
        '<span><i class="fa-solid fa-circle-check"></i> Added Card & Message</span>' +
      '</div>' +
      '<div class="rebuy-cart__gift-container">' +
        '<label for="gift-with-purchase-rebuy">' +
          '<div class="rebuy-cart__gift-message">' +
            '<span>Got Gift Items In Your Cart?</span>' +
          '</div>' +
          '<div class="rebuy-cart__gift-input">' +
            '<input type="checkbox" id="gift-with-purchase-rebuy" name="gift-with-purchase-rebuy" value="Gift with Purchase">' +
            '<span>Add a Card & Message</span>' +
          '</div>' +
        '</label>' +
      '</div>' +
      '<div class="rebuy-cart__gift-variants">' +
        '<div class="rebuy-cart__gift-variants-container">' +
          '<div class="rebuy-cart__gift-variants-content">' +


            '<div class="rebuy-cart__disclaimer-notes">' +
              '<p>Your message will be hand-written on a card. Prices are not shown.</p>' +
            '</div>' +

            '<div class="container-message-card">' +

              '<p>Select your card design</p>' +

              '<div id="rebuy-message-card" class="container-variants-message-card">' +

                /* '<div class="item-variant-message">' +
                  '<input type="radio" id="default" name="message-card-design" value="46395817689258" checked>' +
                  '<label for="default">' +
                    '<img src="https://cdn.shopify.com/s/files/1/0407/7800/6695/files/Navidad_100x.png">' +
                    '<span>Merry Christmas</span>' +
                  '</label>' +
                '</div>' +


                '<div class="item-variant-message">' +
                  '<input type="radio" id="passover" name="message-card-design" value="46615728816298">' +
                  '<label for="passover">' + 
                    '<img src="https://cdn.shopify.com/s/files/1/0407/7800/6695/files/wg-rh-rebuy_100x.png">' +
                    '<span>Rosh Hashana</span>' +
                  '</label>' +
                '</div>' + */


                '<div class="item-variant-message">' +
                  '<input type="radio" id="defaultv2" name="message-card-design" value="47666997854378" checked>' +
                  '<label for="defaultv2">' + 
                    '<img src="https://cdn.shopify.com/s/files/1/0407/7800/6695/files/regular--carrito_100x.png">' +
                    '<span>Default</span>' +
                  '</label>' +
                '</div>' +
    
              '</div>' +

            '</div>' +

            '<div class="container-gift-wrapping container-gift-wrapping--no-personalized">' +

              '<div class="rebuy-cart__gift-images">' +
                '<img src="https://cdn.shopify.com/s/files/1/0407/7800/6695/files/imagen_gift-wrapping-v2.png">' +
              '</div>' +
              '<div class="rebuy-cart__gift-notes">' +
                '<div class="rebuy-cart__gift-message">' +
                  '<label for="notes-gift-wrapping--no-personalized">Message</label>' +
                  '<textarea class="notes-gift-wrapping" id="notes-gift-wrapping--no-personalized" name="properties[Message]" placeholder="Optional..."></textarea>' +
                '</div>' +
              '</div>' +
            
            '</div>' +
    
          '</div>' +
          '<button id="add-gift-rebuy">Add Card & Message</button>' +
        '</div>' +
      '</div>' +
    '</div>'
  );
};


$(document).on('change', '#gift-with-purchase-rebuy', function (){
  if ($(this).is(":checked")) {
    $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants').slideDown();
  } else {
    $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants').slideUp();
    $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants #notes-gift-wrapping').val('');
  };
});


$(document).on('change', '#rebuy-message-card input', function (){
  var inputVariant = $(this).val();
  // console.log('Variante Seleccionada - GIFT MESSAGE: ' + inputVariant);
});


$(document).on('click', '#add-gift-rebuy', function (){

  var selectedRadioGiftMessage = $('#rebuy-message-card input:checked').val();

  var data = {
    "id": selectedRadioGiftMessage,
    "quantity": 1,
    "properties": {
      "Message": $('.rebuy-cart__flyout-gift #notes-gift-wrapping--no-personalized').val()
    }
  };

  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants').slideUp();
      $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants #notes-gift-wrapping--no-personalized').val('');
      $('#gift-with-purchase-rebuy').prop("checked", false);
      $('.rebuy-cart__flyout-gift .message-success-gift').show();
      $('.rebuy-cart__flyout-gift .rebuy-cart__gift-container').hide();
    }
  });

});


function wrapping(qty,gift){

    var $quantity = qty;
    var $gift = gift;

    function $giftPurchase(productId){
      return productId.product_id === 7995381973162;
    };
  
    var $validationGift = $gift.find($giftPurchase);

    /*
    if($quantity > 0){
      $('.rebuy-cart__flyout-body .rebuy-cart__flyout-gift').show();
    } else {
      $('.rebuy-cart__flyout-body .rebuy-cart__flyout-gift').hide();
    };*/

    if ($validationGift !== undefined) {
      if($quantity > 1){
        $('.rebuy-cart__flyout-gift .message-success-gift').show();
        $('.rebuy-cart__flyout-gift .rebuy-cart__gift-container').hide();
        $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants').hide();
        var $qtyGift = $validationGift.quantity;
        if($qtyGift > 1){
          jQuery.post('/cart/update.js', {
            updates: {
              46395817689258: 0,
              46615728816298: 0,
              47666997854378: 0
            }
          });
        };
      } else {
        jQuery.post('/cart/update.js', {
          updates: {
            46395817689258: 0,
            46615728816298: 0,
            47666997854378: 0
          }
        });
      };
    } else {
      $('.rebuy-cart__flyout-gift .message-success-gift').hide();
      $('.rebuy-cart__flyout-gift .rebuy-cart__gift-container').show();
      $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants').hide();
      $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants #notes-gift-wrapping--no-personalized').val('');
      $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants #personalized-gift-wrapping').val('');
      $('.rebuy-cart__flyout-gift .rebuy-cart__gift-variants #notes-gift-wrapping--personalized').val('');
      $('#gift-with-purchase-rebuy').prop("checked", false);
    };

};




/* Script Render GWP */

function $renderContainer(){
  
  if ($('#message-gwp-honey-sticks').length) return;
  $(".rebuy-cart__flyout-body .rebuy-cart__flyout-content").prepend(
      `
      <!--

      <div class="container-progress-bar">
        <div class="elements-progress-bar">
          <h3 class="progress-bar__title">Free shipping on all orders over $99</h3>
          <section class="progress-bar-cart">
          
            <div class="progress-bar-cart__container">
              <div id="progress-bar__free-shipping" class="progress-bar-cart__bar"></div>
            </div>
            <div class="progress-bar__icon">
              <div id="container-icon__free-shipping" class="progress-bar__icon-container">
                <i id="icon__free-shipping" class="fas fa-lock"></i>
              </div>
              <p class="progress-bar__icon-text">Free Shipping</p>
            </div>
            
            <div class="progress-bar-cart__container">
              <div id="progress-bar__pouch" class="progress-bar-cart__bar"></div>
            </div>
            <div class="progress-bar__icon">
              <div id="container-icon__pouch" class="progress-bar__icon-container">
                <i id="icon__pouch" class="fas fa-lock"></i>
              </div>
              <p class="progress-bar__icon-text">Gift With Purchase</p>
            </div>
            
          </section>
          <div class="disclaimer-message">
            <p>* The gift with purchase will be given on purchases over $200.</p>
          </div>
        </div>
    </div>

    -->

   
    <section id="message-gwp-honey-sticks" class="message-gwp">

      <div class="message-gwp__content">


        <div class="container-items-rebuy">
          <div class="honey-gwp-progress">
              <div class="honey-gwp-progress__row">
                <span data-honey-gwp="tag-status">Eligible item: ✕</span>
                <!--<span data-honey-gwp="total-status">$200+: ✕</span>-->
              </div>

              <div class="honey-gwp-progress__track">
                <div class="honey-gwp-progress__bar" data-honey-gwp="bar"></div>
              </div>

              <p class="honey-gwp-progress__text" data-honey-gwp="progress-text">
                Add an eligible item to unlock your free gift
              </p>
            </div>


          <div class="message-gwp__actions">
            <button
              type="button"
              id="honey-gwp-toggle"
              class="honey-gwp-toggle"
              style="display:none;"
              disabled
            >
              Add free gift
            </button>
          </div>

        </div>


        <div class="message-gwp__container">
          <div class="message-gwp__imagen">
            <img src="https://cdn.shopify.com/s/files/1/0407/7800/6695/files/image_honey_gwp.png">
          </div>
          <div class="message-gwp__detail">
            <h3>HONEY STICK</h3>
            <p class="message-offer">Get a free <b>Honey Stick</b> when you shop eligible items.</p>
            <a href="https://www.ilargento.com/collections/rosh-hashanna-2026">Shop Eligible Products</a>
          </div>
        </div>

        <!--
        <div class="message-gwp__variants">
          <div class="message-gwp__variants-containers">
            <div class="variants">

              <div class="variant-item">
                <input type="radio" id="46587106558122" name="gift_rebuy_match" value="46587106558122" checked>
                <label for="46587106558122">
                  <img src="https://cdn.shopify.com/s/files/1/0407/7800/6695/files/Zodax_CH-7346s_9e9413d3-467a-466d-ad91-47afcf439089.jpg">
                  <p>Côte d'Azur - Cannes</p>
                </label>
              </div>

              <div class="variant-item">
                <input type="radio" id="46587106590890" name="gift_rebuy_match" value="46587106590890">
                <label for="46587106590890">
                  <img src="https://cdn.shopify.com/s/files/1/0407/7800/6695/files/Zodax_CH-7349s_3525c3fb-4aa1-4a9e-9f73-948b013a5cb8.jpg">
                  <p>Côte d'Azur - St. Tropez II</p>
                </label>
              </div>

              <div class="variant-item">
                <input type="radio" id="46587106623658" name="gift_rebuy_match" value="46587106623658">
                <label for="46587106623658">
                  <img src="https://cdn.shopify.com/s/files/1/0407/7800/6695/files/CH-5650s_30ccdc56-c2c1-48fc-ad7f-940f72e023f9.png">
                  <p>Match Sticks - Abstract Paint</p>
                </label>
              </div>
            
            </div>
            <button id="add-gift-offert-rebuy">Add to Cart</button>
          </div>
        </div>
        -->

        <p class="disclaimer">* Add your free gift to cart with eligible items. Gift may vary by availability. While supplies last.</p>
      </div> 
    </section>
    
    
    `

    
  );
  
};






/* Script Honey Sticks - Optimized with tag fallback by handle */

const HONEY_GWP_TARGET_TAG = "ELEGIBLE PRODUCT: GIFT WITH PURCHASE";
const HONEY_GWP_MIN_TOTAL_CENTS = 20000;
const HONEY_GWP_REQUIRE_MIN_TOTAL = false;
const HONEY_GWP_GIFT_PRODUCT_ID = 8018492031146;
const HONEY_GWP_GIFT_VARIANT_ID = 46235955888298;
const HONEY_GWP_MAX_RETRIES = 2;
const HONEY_GWP_RETRY_DELAY = 120;

// cache de tags por product_id
const __HONEY_GWP_TAG_CACHE__ = new Map();

function normalizeMoneyToCents(total) {
  if (total == null) return 0;

  if (typeof total === "string") {
    const cleaned = total.replace(/[^0-9.]/g, "");
    const num = Number(cleaned || 0);
    return Math.round(num * 100);
  }

  if (typeof total === "number") {
    if (Number.isInteger(total) && total >= 1000) return total;
    return Math.round(total * 100);
  }

  return 0;
}

function normalizeHoneyTag(tag) {
  return String(tag || "").trim().toUpperCase();
}

function maybeCheckTags(total, arrayProducts) {
  const totalCents = normalizeMoneyToCents(total);
  getTags(totalCents, arrayProducts || []);
}

function getHoneyHandle(item) {
  if (item && item.handle) return item.handle;

  if (item && item.url && typeof item.url === "string") {
    const match = item.url.match(/\/products\/([^/?]+)/i);
    if (match && match[1]) return match[1];
  }

  return null;
}

async function fetchHoneyTagsForItem(item) {
  if (!item) return [];

  const pid = item.product_id;
  if (pid && __HONEY_GWP_TAG_CACHE__.has(pid)) {
    return __HONEY_GWP_TAG_CACHE__.get(pid);
  }

  const handle = getHoneyHandle(item);
  if (!handle) return [];

  try {
    const res = await fetch(`/products/${handle}.js`, {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    });

    if (!res.ok) throw new Error(`HTTP ${res.status}`);

    const data = await res.json();

    let tags = data && data.tags;
    let arr = [];

    if (Array.isArray(tags)) {
      arr = tags.map(t => String(t).trim()).filter(Boolean);
    } else if (typeof tags === "string") {
      arr = tags.split(",").map(t => t.trim()).filter(Boolean);
    }

    if (pid) {
      __HONEY_GWP_TAG_CACHE__.set(pid, arr);
    }

    return arr;
  } catch (e) {
    console.warn("[Honey GWP] No se pudieron leer tags para:", {
      pid,
      handle,
      e
    });
    return [];
  }
}

async function getTags(totalCents, productsArray, retryCount = 0) {
  if (!productsArray || productsArray.length === 0) {
    $("#message-gwp-honey-sticks").show();
    updateHoneyGwpProgress({ hasTag: false, totalCents });
    syncHoneyGiftState(totalCents, [], false);
    return;
  }

  let hasTag = false;
  let hasMissingData = false;

  for (const item of productsArray) {
    if (!item) {
      hasMissingData = true;
      continue;
    }

    // ignorar el regalo mismo al buscar elegibilidad
    if (item.product_id === HONEY_GWP_GIFT_PRODUCT_ID) {
      continue;
    }

    let tagArray = [];

    const tagsRaw = item && item.product && item.product.tags;

    if (tagsRaw) {
      if (Array.isArray(tagsRaw)) {
        tagArray = tagsRaw.map(t => String(t).trim()).filter(Boolean);
      } else if (typeof tagsRaw === "string") {
        tagArray = tagsRaw.split(",").map(t => t.trim()).filter(Boolean);
      }
    } else {
      hasMissingData = true;
      tagArray = await fetchHoneyTagsForItem(item);
    }

    if (
      tagArray
        .map(normalizeHoneyTag)
        .includes(normalizeHoneyTag(HONEY_GWP_TARGET_TAG))
    ) {
      hasTag = true;
      break;
    }
  }

  // fallback pequeño si todavía hay payload incompleto
  if (!hasTag && hasMissingData && retryCount < HONEY_GWP_MAX_RETRIES) {
    setTimeout(() => {
      const snap = window.__HONEY_CART_SNAPSHOT__;
      const freshItems = snap?.items || productsArray;
      getTags(totalCents, freshItems, retryCount + 1);
    }, HONEY_GWP_RETRY_DELAY);
    return;
  }

  const meetsTotal = !HONEY_GWP_REQUIRE_MIN_TOTAL || totalCents >= HONEY_GWP_MIN_TOTAL_CENTS;
  const isEligible = hasTag && meetsTotal;

  updateHoneyGwpProgress({ hasTag, totalCents });
  syncHoneyGiftState(totalCents, productsArray, isEligible);
}

function updateHoneyGwpProgress({ hasTag, totalCents }) {
  const $root = $("#message-gwp-honey-sticks");
  if (!$root.length) return;

  $root.find('[data-honey-gwp="tag-status"]')
    .text(hasTag ? "Eligible item: ✓" : "Eligible item: ✕");

  if (!HONEY_GWP_REQUIRE_MIN_TOTAL) {
    $root.find('[data-honey-gwp="bar"]').css("width", hasTag ? "100%" : "0%");
    $root.find('[data-honey-gwp="progress-text"]').text(
      hasTag
        ? "You unlocked your free Honey Stick 🍯"
        : "Add an eligible item to unlock your free gift"
    );
    return;
  }

  const ratio = Math.max(0, Math.min(1, totalCents / HONEY_GWP_MIN_TOTAL_CENTS));
  const percent = Math.round(ratio * 100);

  const remainingCents = Math.max(0, HONEY_GWP_MIN_TOTAL_CENTS - totalCents);
  const remainingUsd = (remainingCents / 100).toFixed(2);

  $root.find('[data-honey-gwp="bar"]').css("width", `${percent}%`);

  let finalText = "";

  if (hasTag && remainingCents > 0) {
    finalText = `Eligible item ✓ — add $${remainingUsd} more to unlock the gift`;
  } else if (!hasTag && remainingCents > 0) {
    finalText = `Add $${remainingUsd} more to unlock the gift`;
  } else if (!hasTag && remainingCents === 0) {
    finalText = `You’ve reached $200 — add an eligible item to unlock the gift`;
  } else {
    finalText = `Eligible item + $200 reached — add your free gift`;
  }

  $root.find('[data-honey-gwp="progress-text"]').text(finalText);

  $root.find('[data-honey-gwp="tag-status"]')
    .text(hasTag ? "Eligible item: ✓" : "Eligible item: ✕");

  $root.find('[data-honey-gwp="total-status"]')
    .text(remainingCents === 0 ? "$200+: ✓" : "$200+: ✕");
}

function syncHoneyGiftState(totalCents, arrayProducts, isEligible) {

  const giftInCart = (arrayProducts || []).find(
    p => p && p.product_id === HONEY_GWP_GIFT_PRODUCT_ID
  );

  const realProducts = (arrayProducts || []).filter(
    p => p && p.product_id !== HONEY_GWP_GIFT_PRODUCT_ID
  );

  const $button = $("#honey-gwp-toggle");

  if ($button.length) {
    $button
      .hide()
      .prop("disabled", true)
      .removeClass("is-added is-remove")
      .attr("data-action", "add")
      .text("Add free gift");
  }

  // carrito vacío o solo con regalo
  if (realProducts.length === 0 || (HONEY_GWP_REQUIRE_MIN_TOTAL && totalCents <= 0)) {
    if (giftInCart) {
      jQuery.post("/cart/update.js", {
        updates: { [HONEY_GWP_GIFT_VARIANT_ID]: 0 }
      }).done(() => {
        console.log("❌ Regalo eliminado: carrito vacío o sin productos.");
      });
    }
    return;
  }

  // no elegible
  if (!isEligible) {
    if (giftInCart) {
      jQuery.post("/cart/update.js", {
        updates: { [HONEY_GWP_GIFT_VARIANT_ID]: 0 }
      }).done(() => {
        console.log("❌ Regalo eliminado: no cumple condiciones.");
      });
    }
    return;
  }

  // corregir duplicados
  if (giftInCart && giftInCart.quantity > 1) {
    jQuery.post("/cart/update.js", {
      updates: { [HONEY_GWP_GIFT_VARIANT_ID]: 1 }
    }).done(() => {
      console.log("🔄 Regalo ajustado a 1 unidad.");
    });

    if ($button.length) {
      $button
        .show()
        .prop("disabled", false)
        .addClass("is-added is-remove")
        .attr("data-action", "remove")
        .text("Remove free gift");
    }
    return;
  }

  // ya agregado
  if (giftInCart && giftInCart.quantity === 1) {
    if ($button.length) {
      $button
        .show()
        .prop("disabled", false)
        .addClass("is-added is-remove")
        .attr("data-action", "remove")
        .text("Remove free gift");
    }
    return;
  }

  // elegible y no agregado
  if ($button.length) {
    $button
      .show()
      .prop("disabled", false)
      .removeClass("is-added is-remove")
      .attr("data-action", "add")
      .text("Add free gift");
  }
}

$(document).on("click", "#honey-gwp-toggle", function () {
  const $button = $(this);
  const action = $button.attr("data-action");

  if ($button.prop("disabled")) return;

  $button.prop("disabled", true);

  if (action === "remove") {
    $button.text("Removing...");

    jQuery.post("/cart/update.js", {
      updates: { [HONEY_GWP_GIFT_VARIANT_ID]: 0 }
    })
      .done(function () {
        console.log("❌ Regalo eliminado manualmente.");
        $button
          .removeClass("is-added is-remove")
          .attr("data-action", "add")
          .text("Add free gift");
      })
      .fail(function () {
        console.error("❌ Error al eliminar el regalo.");
        $button
          .addClass("is-added is-remove")
          .attr("data-action", "remove")
          .text("Remove free gift");
      })
      .always(function () {
        $button.prop("disabled", false);
      });

    return;
  }

  $button.text("Adding...");

  jQuery.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      id: HONEY_GWP_GIFT_VARIANT_ID,
      quantity: 1
    },
    dataType: "json",
    success: function () {
      console.log("✅ Regalo agregado manualmente.");
      $button
        .addClass("is-added is-remove")
        .attr("data-action", "remove")
        .text("Remove free gift");
    },
    error: function () {
      console.error("❌ Error al agregar el regalo.");
      $button
        .removeClass("is-added is-remove")
        .attr("data-action", "add")
        .text("Add free gift");
    },
    complete: function () {
      $button.prop("disabled", false);
    }
  });
});








/* ============================================
   SCRIPT — VALIDACIÓN DE WRAPPING POR TAG
   ============================================ */

/* 1. Función principal */
function maybeCheckWrappingTags(total, arrayProducts) {
  getWrappingTags(total, arrayProducts);
}

/* 2. Detectar productos elegibles */
function getWrappingTags(total, productsArray, retryCount = 0) {
  const maxRetries = 10;
  const targetTag = 'WRAPPING_AVAILABLE';

  if (!productsArray || productsArray.length === 0) {
    console.warn("Carrito vacío o sin items al validar wrapping.");
    hideAndCleanWrapping();
    return;
  }

  let foundTag = false;
  let hasNullProduct = false;

  for (let i = 0; i < productsArray.length; i++) {
    const item = productsArray[i];

    if (!item || !item.product || !item.product.tags) {
      console.warn(`Intento ${retryCount + 1}: Producto inválido en la posición ${i}`, item);
      hasNullProduct = true;
      break;
    }

    let tagArray = item.product.tags;
    if (typeof tagArray === 'string') {
      tagArray = tagArray.split(',').map(tag => tag.trim());
    }

    if (tagArray.includes(targetTag)) {
      foundTag = true;
      break;
    }
  }

  if (hasNullProduct && retryCount < maxRetries) {
    console.warn(`Reintentando obtener tags de wrapping en 200ms... (Intento ${retryCount + 1} de ${maxRetries})`);
    setTimeout(() => getWrappingTags(total, productsArray, retryCount + 1), 200);
    return;
  }

  if (hasNullProduct && retryCount === maxRetries) {
    console.error("Error persistente: No se pudieron obtener los tags de wrapping después de 10 intentos.");
    return;
  }

  const eligibility = foundTag ? 'AVAILABLE' : 'NONE';
  handleGiftWrappingEligibility(eligibility, total, productsArray);
}

/* 3. Acción según elegibilidad */
function handleGiftWrappingEligibility(eligibility, total, arrayProducts) {
  const WRAP_PRODUCT_ID = 7995381973162;
  const WRAP_VARIANT_1 = 46395817689258;
  const WRAP_VARIANT_2 = 46615728816298;
  const WRAP_VARIANT_3 = 47666997854378;

  const wrapInCart = arrayProducts.find(p => p.product_id === WRAP_PRODUCT_ID);

  if (eligibility === 'NONE') {
    // Ocultar UI
    hideAndCleanWrapping();

    // Si existía wrapping → eliminarlo
    if (wrapInCart) {
      jQuery.post('/cart/update.js', {
        updates: {
          [WRAP_VARIANT_1]: 0,
          [WRAP_VARIANT_2]: 0,
          [WRAP_VARIANT_3]: 0
        }
      }).done(() => console.log("❌ Wrapping eliminado por no ser elegible."));
    }

    return;
  }

  // SI ES ELEGIBLE → mostrar UI
  $('.rebuy-cart__flyout-gift').show();
}

/* 4. Función utilitaria para esconder UI y limpiar inputs */
function hideAndCleanWrapping() {
  $('.rebuy-cart__flyout-gift').hide();

  // limpiar campos, estados, radio buttons, textarea, etc.
  $('#gift-with-purchase-rebuy').prop("checked", false);
  $('.rebuy-cart__gift-variants').hide();
  $('.notes-gift-wrapping').val('');
}





















/* Script Progress Bar */

function $progressBar(totalPrice,arrayProducts){

    var $total_price = totalPrice;
    var $array_products = arrayProducts;

    var $price_promotion_one = 9900 - $total_price; var $promotion_one = $price_promotion_one /= Math.pow(10, 2); var $porcentPromotionOne = ((99.00 - $promotion_one) / 99.00 * 100) + "%";

    // var $price_promotion_one = 1 - $total_price; var $promotion_one = $price_promotion_one /= Math.pow(10, 2); var $porcentPromotionOne = ((0.01 - $promotion_one) / 0.01 * 100) + "%";
    var $price_promotion_two = 20000 - $total_price; var $promotion_two = $price_promotion_two /= Math.pow(10, 2); var $porcentPromotionTwo = ((200.00 - $promotion_two) / 200.00 * 100) + "%";

    
  
    if($total_price <= 0){

      $("#progress-bar__free-shipping,#progress-bar__5-off,#progress-bar__pouch").animate({width: "0%",}, 1000);
      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-lock"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-lock"></i>');
      $("#container-icon__free-shipping,#container-icon__pouch").css({"background-color": "#fff", "border-color": "#a0937c"});
      $("#icon__free-shipping,#icon__pouch").css("color", "#a0937c");
      
       $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">Free shipping on all orders over $99</h3>');
      // $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">Free shipping on all orders</h3>');
      
    
    } else if($total_price > 0 && $total_price <= 9899){

      $("#progress-bar__free-shipping").animate({width: $porcentPromotionOne,}, 500);
      $("#progress-bar__pouch").animate({width: "0%",}, 500);

      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-lock"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-lock"></i>');

      $("#container-icon__free-shipping,#container-icon__pouch").css({"background-color": "#fff", "border-color": "#a0937c"});
      $("#icon__free-shipping,#icon__pouch").css("color", "#a0937c");

      
      $(".progress-bar__title").replaceWith(
        '<div class="progress-bar__title">'+
          '<h3>You need <b>$' + $promotion_one + '</b> to get free shipping</h3>' +
        '</div>'
      );

    } else if($total_price > 9900 && $total_price <= 19999){
    


   /* } else if($total_price > 0 && $total_price <= 19999){*/

      $("#progress-bar__free-shipping").animate({width: "100%",}, 500);
      $("#progress-bar__pouch").animate({width: $porcentPromotionTwo,}, 500);
      
      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-check-circle"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-lock"></i>')
      
      $("#container-icon__free-shipping").css({"background-color": "#a0937c", "border-color": "#a0937c"});
      $("#container-icon__pouch").css({"background-color": "#fff", "border-color": "#a0937c"});

      $("#icon__free-shipping").css("color", "#fff");
      $("#icon__pouch").css("color", "#a0937c");

      $(".progress-bar__title").replaceWith(
        '<div class="progress-bar__title">'+
          '<h3>You need <b>$' + $promotion_two + '</b> to get $25 gift card</h3>' +
          '<h5>You unlocked free shipping</h5>'+
        '</div>'
      );

    } else if($total_price >= 20000){

      

      $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">You unlocked free shipping + gift card</h3>');

      $("#progress-bar__free-shipping").animate({width: "100%",}, 500);
      $("#progress-bar__pouch").animate({width: "100%",}, 500);

      $("#icon__free-shipping").replaceWith('<i id="icon__free-shipping" class="fas fa-check-circle"></i>');
      $("#icon__pouch").replaceWith('<i id="icon__pouch" class="fas fa-check-circle"></i>');

      $("#container-icon__free-shipping,#container-icon__pouch").css({"background-color": "#a0937c", "border-color": "#a0937c"});

      $("#icon__free-shipping,#icon__pouch").css("color", "#fff");
      
    };
  
};


$(document).on('click', '.colors-towel-gift', function (){
  $('.colors-towel-gift').removeClass('active-radio');
  $(this).addClass('active-radio');
  $(this).is(':checked');
  id = $(this).val();
  console.log(id);
});


$(document).on('click', '.add-promotions-surprise-btn-1', function() { 
  var seleccion = $('.colors-towel-gift:checked').val();
  var data = {
    "id": seleccion,
    "quantity": 1
  }
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    success: function() { 
      $(".progress-bar__title").replaceWith('<h3 class="progress-bar__title">You unlocked free shipping + gift candle</h3>');
    }
  });
});








/* Triggers Rebuy Events */

document.addEventListener('rebuy:smartcart.ready', function(event){
  console.log('rebuy:smartcart.ready event', event.detail);
  var $qty = event.detail.smartcart.cart.item_count;
  var $total_price = event.detail.smartcart.cart.total_price;
  var $array_products = event.detail.smartcart.cart.items;


  $('#rebuy-cart .rebuy-cart__flyout-content').on('scroll', function() {
    if ($(this).scrollTop() > 0) {
      $('#rebuy-cart .rebuy-cart__flyout-header').addClass('scroll-move-header');
    } else {
      $('#rebuy-cart .rebuy-cart__flyout-header').removeClass('scroll-move-header');
    }
  });

  /*
  $renderContainer();
  // $progressBar($total_price,$array_products);
  window.__HONEY_CART_SNAPSHOT__ = { total_price: $total_price, items: $array_products };
  maybeCheckTags($total_price, $array_products);
  */


  $reindexacionRebuy();
  ajustarAltura();


  giftWrapping();
  wrapping($qty,$array_products);
  maybeCheckWrappingTags($total_price, $array_products);



  renderGroupSet();
  setTimeout(GroupSet, 1000);

});

document.addEventListener('rebuy:cart.change', function(event){
  console.log('rebuy:cart.change event', event.detail);

  var $qty_rebuy = event.detail.cart.cart.item_count;
  var $array_products = event.detail.cart.cart.items;
  var $total_price = event.detail.cart.cart.total_price;


  if($qty_rebuy > 0){
    $('.Header__CartDot').addClass('is-visible');
  } else {
    $('.Header__CartDot').removeClass('is-visible');
  };



  /*var $container_progress = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .container-progress-bar');
  if ($container_progress.length > 0) {
    $progressBar($total_price,$array_products);
  };*/


  /*
  var containerGiftHoney = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content #message-gwp-honey-sticks');
  if (containerGiftHoney.length > 0) {
    window.__HONEY_CART_SNAPSHOT__ = { total_price: $total_price, items: $array_products };
    maybeCheckTags($total_price, $array_products);
  }*/

  

  var $containerGift = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-gift');
  if ($containerGift.length > 0) {
    wrapping($qty_rebuy,$array_products);
  }; 
  maybeCheckWrappingTags($total_price, $array_products);


  var $containerSets = $('.rebuy-cart__flyout-body .rebuy-cart__flyout-sets');
  if ($containerSets.length > 0) {
    setTimeout(GroupSet, 1000);
  };
  
});



/* Script para SETS */

function renderGroupSet(){
  $('.rebuy-cart__flyout-body #message-gwp-honey-sticks').after('<div class="rebuy-cart__flyout-sets"><h4 id="heading-product-sets">Product Sets:</h4></div><div class="title-simple-products">Individual Products:</div>');
};



function GroupSet(){

  var grupos = {};
  var cantidadElementos = 0;
  var lineItemsBasic = 0;
    
  $("div#rebuy-cart ul.rebuy-cart__flyout-items li.rebuy-cart__flyout-item").each(function() {
  
      var classes = $(this).attr("class").split(" ");
      var idClass = classes.find(function(className) {
          return className.startsWith("property-id-set:"); 
      });
  
      if (idClass) {
          var id = idClass.split(":")[1];
        
          if (!grupos[id]) {
              grupos[id] = [];
          };
          
          grupos[id].push(this);
      } else {
        
        lineItemsBasic++;
        
      };
      
  });

  for (var id in grupos) {
    if($('div#rebuy-cart .rebuy-cart__flyout-sets ul.' + id).length === 0){
      

      var lista = $("<ul class='" + id + "'></ul>");
      
      var containerSet = $(`
        <div class="container-set-rebuy container-set-rebuy--${id}">
          <div class="rebuy-cart__flyout-item">
            <div class="rebuy-cart__flyout-item-media">
              <a href="/products/golden-handles-sets" tabindex="-1">
                <img src="https://cdn.shopify.com/s/files/1/0407/7800/6695/files/Sets-de-Golden-Handles-_FOTOS__0001_Set-Appetizer_240x240.png">
              </a>
            </div>
            <div class="rebuy-cart__flyout-item-info">
              <a role="heading" aria-level="5" href="/products/golden-handles-sets" class="rebuy-cart__flyout-item-product-title">
                Golden Handles Sets
              </a>
              <div class="rebuy-cart__flyout-item-discount-message rebuy-cart__flyout-item-discount-message--hide"></div>
              <div class="rebuy-cart__flyout-item-properties">
                <div class="rebuy-cart__flyout-item-property property-key-id-set">
                  <span class="rebuy-cart__flyout-item-property-name">ID SET</span>
                  <span class="rebuy-cart__flyout-item-property-separator">:</span>
                  <span class="rebuy-cart__flyout-item-property-value">${id}</span>
                </div>

                <div class="rebuy-cart__flyout-item-property property-key-id-set-title">
                  <span class="rebuy-cart__flyout-item-property-name">SET</span>
                  <span class="rebuy-cart__flyout-item-property-separator">:</span>
                  <span class="rebuy-cart__flyout-item-property-value"></span>
                </div>
              </div>
              <button type="button" class="rebuy-cart__flyout-item-remove">
                <i aria-hidden="true" class="far fa-trash"></i>
              </button>
              <div class="rebuy-cart__flyout-item-quantity">
                <div class="container-button-view-all-products">
                  <span class="view-products button-active">View Products</span>
                </div>
              </div>
              <div class="rebuy-cart__flyout-item-price">
                <div>
                  <span class="rebuy-money-sale"><span></span></span>
                  <span class="rebuy-money-regular"><span class="sr-only">Price</span> <span></span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      `);



      
      var elementosOriginales = grupos[id];


      if (elementosOriginales.length >= 1) {
        elementosOriginales.forEach(function(elementoOriginal) {
            var copiaElemento = $(elementoOriginal).clone();
            lista.append(copiaElemento);
        }); 
      };
      

      $('.rebuy-cart__flyout-sets').prepend(containerSet);
      $('.rebuy-cart__flyout-sets .container-set-rebuy--' + id +'').append(lista);
      
    };

    cantidadElementos++;

  };


  $('.rebuy-cart__flyout-sets').prepend($('#heading-product-sets'));


  $('.rebuy-cart__flyout-sets .container-set-rebuy').each(function(){
      var selector = $(this).find('> div.rebuy-cart__flyout-item');
      var items = $(this).find('ul li');
      var totalSet = 0;
      var totalSetOffer = 0;
      var totalSetRegular = 0;
      items.each(function(){

        if($(this).hasClass('property-alexia-set:product-1-of-3')){
          let nameSet = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-properties .property-value-product-1-of-3 .rebuy-cart__flyout-item-property-name').text();
          let discount = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-discount-message');
          if (discount.length > 0) {
            $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-discount-message').text(discount.text());
            $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-discount-message').removeClass('rebuy-cart__flyout-item-discount-message--hide');
          };
          $(selector).find('.rebuy-cart__flyout-item-info .property-key-id-set-title .rebuy-cart__flyout-item-property-value').text(nameSet);
          $(selector).find('.rebuy-cart__flyout-item-media > a > img').attr('src', 'https://cdn.shopify.com/s/files/1/0407/7800/6695/files/Sets-de-Golden-Handles-_FOTOS__0002_Set-Alexia_240x240.png');
        };

        if($(this).hasClass('property-appetizer-set:product-1-of-3')){
          let nameSet = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-properties .property-value-product-1-of-3 .rebuy-cart__flyout-item-property-name').text();
          let discount = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-discount-message');
          if (discount.length > 0) {
            $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-discount-message').text(discount.text());
            $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-discount-message').removeClass('rebuy-cart__flyout-item-discount-message--hide');
          };
          $(selector).find('.rebuy-cart__flyout-item-info .property-key-id-set-title .rebuy-cart__flyout-item-property-value').text(nameSet);
          $(selector).find('.rebuy-cart__flyout-item-media > a > img').attr('src', 'https://cdn.shopify.com/s/files/1/0407/7800/6695/files/Sets-de-Golden-Handles-_FOTOS__0001_Set-Appetizer_240x240.png');
        };

        if($(this).hasClass('property-fancy-dinner-set:product-1-of-3')){
          let nameSet = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-properties .property-value-product-1-of-3 .rebuy-cart__flyout-item-property-name').text();
          let discount = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-discount-message');
          if (discount.length > 0) {
            $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-discount-message').text(discount.text());
            $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-discount-message').removeClass('rebuy-cart__flyout-item-discount-message--hide');
          };
          $(selector).find('.rebuy-cart__flyout-item-info .property-key-id-set-title .rebuy-cart__flyout-item-property-value').text(nameSet);
          $(selector).find('.rebuy-cart__flyout-item-media > a > img').attr('src', 'https://cdn.shopify.com/s/files/1/0407/7800/6695/files/Sets-de-Golden-Handles-_FOTOS__0000_Set-fancy-dinner-1_240x240.png');
        };

        /* Precio Normal sin Descuento */
        let priceValue = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money span:not(.sr-only)').text();
        let price = Math.round(parseFloat(priceValue.replace(/[$,]/g, '')) * 100);
        totalSet += price;

        /* Precio Oferta con Cupón */
        let priceSaleValue = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money.sale span:not(.sr-only)').text();
        let priceSale = Math.round(parseFloat(priceSaleValue.replace(/[$,]/g, '')) * 100);
        totalSetOffer += priceSale;

        /* Precio Regular con Cupón */
        let priceRegularValue = $(this).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money.compare-at span:not(.sr-only)').text();
        let priceRegular = Math.round(parseFloat(priceRegularValue.replace(/[$,]/g, '')) * 100);
        totalSetRegular += priceRegular;
        
      });

      if(totalSetOffer > 0){
        $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money-regular').addClass('rebuy-money-regular__crossline');
        $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money-sale span:not(.sr-only)').text((totalSetOffer / 100).toLocaleString("en-US", {style: "currency", currency: "USD"}));
        $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money-regular span:not(.sr-only)').text((totalSetRegular / 100).toLocaleString("en-US", {style: "currency", currency: "USD"}));
      } else {
        $(selector).find('.rebuy-cart__flyout-item-info .rebuy-cart__flyout-item-price .rebuy-money-regular span:not(.sr-only)').text((totalSet / 100).toLocaleString("en-US", {style: "currency", currency: "USD"}));
      }

  });



  
  
  if(cantidadElementos > 0){
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets').css('display','flex');
  } else {
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets').hide();
  };

  if(lineItemsBasic > 0){
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-items').show();
  } else {
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-items').hide();
  };


  if(cantidadElementos > 0 && lineItemsBasic > 0){
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets h4').show();
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .title-simple-products').show();
  } else {
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .rebuy-cart__flyout-sets h4').hide();
    $('.rebuy-cart__flyout-body .rebuy-cart__flyout-content .title-simple-products').hide();
  };


};




$(document).on('click', '.container-set-rebuy button.rebuy-cart__flyout-item-remove', function () {
    var $selectorItem = ($(this).parents('.container-set-rebuy').find('> ul').attr('class')).toUpperCase();
    var $selectorProducts = $(this).parents('.container-set-rebuy').find('> ul').attr('class');
    console.log('Selector Products:', $selectorItem);

    var $removeSet = $('.rebuy-cart__flyout-sets .container-set-rebuy--' + $selectorProducts);
    $($removeSet).replaceWith('<div class="container-set-rebuy--' + $selectorProducts +' rebuy-cart__flyout-sets--deleted"><div class="load-more__spinner"></div><p>Remove set</p></div>');

    $.getJSON('/cart.js', function(cart) {
        console.log('Carrito obtenido:', cart);
        var updatesObj = {};

        var itemsToDelete = cart.items.filter(item => item.properties && item.properties['ID SET'] === $selectorItem);
        console.log('Items to Delete:', itemsToDelete);

        itemsToDelete.forEach(function(item) {
            updatesObj[item.key] = 0;
        });

        console.log('Updates Object:', updatesObj);

        if (Object.keys(updatesObj).length > 0) {
            $.post('/cart/update.js', {
                updates: updatesObj
            }, function(response) {
                console.log('Carrito actualizado:', response);
                $('.container-set-rebuy--' + $selectorProducts).remove();
            }).fail(function(error) {
                console.error('Error al actualizar el carrito', error);
            });
        }
    }).fail(function(error) {
        console.error('Error al obtener el carrito:', error);
    });
});



$(document).on('click', '.container-set-rebuy .container-button-view-all-products span.view-products.button-active', function (){
  $(this).parents('.container-set-rebuy').find('> ul').slideDown();
  $(this).text('Hide Products');
  $(this).removeClass('button-active');
  $(this).addClass('button-off');
});

$(document).on('click', '.container-set-rebuy .container-button-view-all-products span.view-products.button-off', function (){
  $(this).parents('.container-set-rebuy').find('> ul').slideUp();
  $(this).text('View Products');
  $(this).removeClass('button-off');
  $(this).addClass('button-active');
});